import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import AgeGate from "./components/AgeGate";
import HomePage from "./pages/HomePage";
import ShopPage from "./pages/ShopPage";
import ProductDetail from "./pages/ProductDetail";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import CookieConsent from "./components/CookieConsent";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import CheckoutPage from "./pages/CheckoutPage";
import AdminPage from "./pages/AdminPage";
import AdminLogin from "./pages/AdminLogin";

function App() {
  const [ageVerified, setAgeVerified] = useState(false);

  useEffect(() => {
    const verified = localStorage.getItem('seltz_age_verified');
    const expiry = localStorage.getItem('seltz_age_verified_expiry');
    const now = new Date().getTime();

    // Check if verification exists and hasn't expired
    if (verified === 'true' && expiry && now < parseInt(expiry)) {
      setAgeVerified(true);
    } else {
      // Clear expired or invalid verification
      localStorage.removeItem('seltz_age_verified');
      localStorage.removeItem('seltz_age_verified_expiry');
      setAgeVerified(false);
    }

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('age_ok') === '1') {
      setAgeVerified(true);
    }
  }, []);

  if (!ageVerified) {
    return <AgeGate onVerified={() => setAgeVerified(true)} />;
  }

  return (
    <CartProvider>
      <BrowserRouter>
        <div className="App">
          <Routes>
            {/* Admin routes - no Navbar/Footer */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminPage />} />

            {/* Main site routes */}
            <Route path="/" element={<><Navbar /><CartDrawer /><HomePage /><Footer /><CookieConsent /></>} />
            <Route path="/shop" element={<><Navbar /><CartDrawer /><ShopPage /><Footer /><CookieConsent /></>} />
            <Route path="/products/:id" element={<><Navbar /><CartDrawer /><ProductDetail /><Footer /><CookieConsent /></>} />
            <Route path="/about" element={<><Navbar /><CartDrawer /><AboutPage /><Footer /><CookieConsent /></>} />
            <Route path="/contact" element={<><Navbar /><CartDrawer /><ContactPage /><Footer /><CookieConsent /></>} />
            <Route path="/terms" element={<><Navbar /><CartDrawer /><TermsPage /><Footer /><CookieConsent /></>} />
            <Route path="/privacy" element={<><Navbar /><CartDrawer /><PrivacyPage /><Footer /><CookieConsent /></>} />
            <Route path="/checkout" element={<><Navbar /><CartDrawer /><CheckoutPage /><Footer /><CookieConsent /></>} />
            <Route path="*" element={<><Navbar /><CartDrawer /><HomePage /><Footer /><CookieConsent /></>} />
          </Routes>
        </div>
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
